var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-wrapper" },
    [
      _c(
        "v-form",
        _vm._b(
          {
            on: { validate: _vm.validateStep, submit: _vm.validateAll },
            scopedSlots: _vm._u([
              {
                key: "step-0",
                fn: function() {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.designer,
                          expression: "form.designer"
                        }
                      ],
                      attrs: {
                        name: "designer",
                        id: "designer",
                        placeholder: _vm.translation.designer
                      },
                      domProps: { value: _vm.form.designer },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "designer", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.furniture_type,
                          expression: "form.furniture_type"
                        }
                      ],
                      attrs: {
                        name: "furniture_type",
                        id: "furniture_type",
                        placeholder: _vm.translation.mobel
                      },
                      domProps: { value: _vm.form.furniture_type },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "furniture_type",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.material_name,
                          expression: "form.material_name"
                        }
                      ],
                      attrs: {
                        name: "material_name",
                        id: "material_name",
                        placeholder: _vm.translation.materiale
                      },
                      domProps: { value: _vm.form.material_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "material_name",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.condition,
                          expression: "form.condition"
                        }
                      ],
                      attrs: {
                        name: "condition",
                        id: "condition",
                        placeholder: _vm.translation.stand
                      },
                      domProps: { value: _vm.form.condition },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "condition", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.furniture_price,
                          expression: "form.furniture_price"
                        }
                      ],
                      attrs: {
                        name: "furniture_price",
                        id: "furniture_price",
                        placeholder: _vm.translation.pris
                      },
                      domProps: { value: _vm.form.furniture_price },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "furniture_price",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.files_error,
                              expression: "files_error"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "myFiles",
                        attrs: {
                          name: "upload",
                          type: "file",
                          id: "upload",
                          accept: "image/png, image/jpeg",
                          multiple: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.uploadfiles()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-placeholder",
                          on: { click: _vm.openUpload }
                        },
                        [
                          _vm.files.length == 0
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.translation.no_files) +
                                    "\n          "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.translation.success_files) +
                                    " (" +
                                    _vm._s(_vm.files.length) +
                                    ")"
                                )
                              ])
                        ]
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "step-1",
                fn: function() {
                  return [
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.name"),
                              expression: "errors.has('form-2.name')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_format))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.name,
                            expression: "form.name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          id: "name",
                          name: "name",
                          placeholder: _vm.translation.name,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.address"),
                              expression: "errors.has('form-2.address')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_format))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.address,
                            expression: "form.address"
                          }
                        ],
                        attrs: {
                          id: "address",
                          name: "address",
                          placeholder: _vm.translation.postnumber,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "address", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.phone"),
                              expression: "errors.has('form-2.phone')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_format))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|decimal",
                            expression: "'required|decimal'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.phone,
                            expression: "form.phone"
                          }
                        ],
                        key: "phone-input",
                        attrs: {
                          id: "phone",
                          name: "phone",
                          placeholder: _vm.translation.phone,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "phone", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.email"),
                              expression: "errors.has('form-2.email')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.email,
                            expression: "form.email"
                          }
                        ],
                        key: "email-input",
                        attrs: {
                          id: "email",
                          name: "email",
                          placeholder: _vm.translation.email,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "email", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "step-2",
                fn: function() {
                  return [
                    _c("div", { staticClass: "radio-wrapper" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-3.radio-group"),
                              expression: "errors.has('form-3.radio-group')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "radio-group" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.translation.flow_form_agreed) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "custom-radio-buttons" }, [
                        _c("li", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.barter,
                                expression: "form.barter"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "radio",
                            attrs: {
                              value: "yes",
                              type: "radio",
                              id: "rb-1",
                              name: "radio-group",
                              "data-vv-scope": "form-3"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.barter, "yes")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "barter", "yes")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "rb-1" } }, [
                            _vm._v(_vm._s(_vm.translation.yes))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.barter,
                                expression: "form.barter"
                              }
                            ],
                            staticClass: "radio",
                            attrs: {
                              value: "no",
                              type: "radio",
                              id: "rb-2",
                              name: "radio-group",
                              "data-vv-scope": "form-3"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.barter, "no")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "barter", "no")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "rb-2" } }, [
                            _vm._v(_vm._s(_vm.translation.no))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.message,
                          expression: "form.message"
                        }
                      ],
                      attrs: {
                        name: "message",
                        placeholder: _vm.translation.comment
                      },
                      domProps: { value: _vm.form.message },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "message", $event.target.value)
                        }
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          },
          "v-form",
          {
            steps: _vm.steps,
            text_top: _vm.text_top,
            text_bottom: _vm.text_bottom,
            type: _vm.type,
            form: _vm.form,
            terms: _vm.terms
          },
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }